import RequestAbstract from '../abstract';

export default class SmeCompanies extends RequestAbstract {
    constructor(data) {
        super(data);
        this.link = 'api/sme-companies';
    }

    /**
     * Top-up multiple employee wallets from an SME company wallet.
     * Body example:
     * {
     *   fromWalletId: 123,
     *   transfers: [ { toWalletId: 456, amount: 100 } ]
     * }
     * @param {{fromWalletId:number, transfers:Array<{toWalletId:number, amount:number}>}} payload Payload describing the top-up operation.
     * @returns {Promise<any>} server response
     */
    async topUp(payload) {
        return await this.loadWithAuth(`${this.link}/topup`, {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    }

    /**
     * Fetch a single SME company by its ID.
     * @param {number|string} id SME company ID
     * @returns {Promise<any>} server response
     */
    async getById(id) {
        return await this.get(`${this.link}/${id}`);
    }
}
